import _ from 'underscore';
import Backbone from 'backbone';
import templateHtml from 'views/gdpr/privacy/templates/privacyItem.html';

export default Backbone.View.extend({
    events: {
        'click input.privacy-checkbox': 'onOptionChange'
    },

    template: _.template(templateHtml),
    tagName: 'div',

    initialize: function(args) {
        this.privacyText = args.privacyText;
        this.onGrantChange = args.onGrantChange;
    },

    render: function() {
        var feature = this.privacyText.toJSON();
        var link = feature && feature[0] ? feature[0].consentLinks[0] : {};
        var copyBlock = feature && feature[0] ? feature[0].consentCopyBlocks[0] : {};

        this.$el.html(
            this.template({
                text: link.text,
                link: link.url,
                copy: copyBlock.copy
            })
        );

        return this;
    },

    onOptionChange: function(e) {
        this.onGrantChange(e.currentTarget.checked);
    }
});
